<template>
    <div>

        <v-snackbar app top dark rounded :color="snackColor" v-model="showSnack">
            {{  this.snackText }}
            <template v-slot:action="{ attrs }">
                <v-icon v-bind="attrs"
                @click="showSnack = false">mdi-close</v-icon>
            </template>
        </v-snackbar>

        <v-container>
            <v-data-table
              :headers="headersWithProperties"
              :items="registros"
              dense
              class="elevation-7"
              locale="pt"
              style="border-radius: 10px; margin-top: 20px;"
              :disable-pagination="true"
              :disable-sort="true"
              :fixed-header="true"
              :hide-default-footer="true"
              :mobile-breakpoint="0"
              :loading="loading"
              @click:row="(item) => openEditDialog(item)"
            >
                <template v-slot:top>
                    <v-toolbar flat color="white" style="border-radius: 10px;">
                        <v-toolbar-title style="color: #4a4a4a">{{$t('turnstile.launch')}}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" dark fab small style="margin-right: 5px;" @click="resetTabelaRegistros"><v-icon>mdi-reload</v-icon></v-btn>
                        <v-btn color="primary" dark fab small @click="apagaTabelaRegistros"><v-icon>mdi-eraser</v-icon></v-btn>
                    </v-toolbar>
                </template>
            </v-data-table>
        </v-container>

        <v-dialog
            v-model="editDialog"
        >
            <v-dialog v-model="deleteDialog" width="90%">
                <v-card>
                    <v-card-title>
                        <span class="headline" style="color: red">{{$t('system.alert')}}</span>
                    </v-card-title>
                    <v-card-text>
                        <span class="headline" style="color: red">{{$t('turnstile.confirmDeleteLaunch')}}</span>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" dark @click="deleteDialog = false">{{$t('button.dismiss')}}</v-btn>
                        <v-btn color="red" dark @click="deleteRegistro">{{$t('button.confirm')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-card>
                <v-card-title>
                    <span class="headline" style="color: #4a4a4a">{{$t('turnstile.launchOf')}} {{ registro.dt_registro_extenso }}</span>
                </v-card-title>
                <v-card-text>
                    <div>
                        <v-row justify="center">
                            <v-col cols="12" sm="6">
                                <v-card>
                                    <v-card-text>
                                        <v-container>
                                            <v-row justify="start">
                                                <v-col cols="12" sm="3">
                                                    <strong>{{$tc('vehicle.self', 1)}}: </strong>
                                                </v-col>
                                                <v-col cols="12" sm="3">
                                                    <span>{{ registro.numero_ordem }}</span>
                                                </v-col>
                                                <v-col cols="12" sm="2"></v-col>
                                            </v-row>
                                            <v-row justify="start">
                                                <v-col cols="12" sm="3">
                                                    <strong>{{$tc('turnstile.self', 1)}}:</strong>
                                                </v-col>
                                                <v-col cols="12" sm="3">
                                                    <span>{{ registro.roleta }}</span>
                                                </v-col>
                                                <v-col cols="12" sm="2">
                                                    <v-icon 
                                                        v-if="registro.img_roleta_path" color="green">
                                                        mdi-image-check
                                                    </v-icon>
                                                    <v-icon 
                                                        v-else color="red">
                                                        mdi-image-remove
                                                    </v-icon>
                                                </v-col>
                                            </v-row>
                                            <v-row justify="start">
                                                <v-col cols="12" sm="3">
                                                    <strong>{{ $t('turnstile.odometer') }}:</strong>
                                                </v-col>
                                                <v-col cols="12" sm="3">
                                                    <span>{{ registro.odometro }}</span>
                                                </v-col>
                                                <v-col cols="12" sm="2">
                                                    <v-icon 
                                                        v-if="registro.img_odometro_path" color="green">
                                                        mdi-image-check
                                                    </v-icon>
                                                    <v-icon 
                                                        v-else color="red">
                                                        mdi-image-remove
                                                    </v-icon>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn dark color="primary" @click="closeEditDialog">{{ $t('button.cancel') }}</v-btn>
                    <v-btn dark color="red" @click="openDeleteDialog">{{ $t('button.delete') }}</v-btn>
                </v-card-actions>
            </v-card>

        </v-dialog>

        <v-dialog
            v-model="dialog"
            eager
        >
            <v-card>
                <v-card-title>
                    <span class="headline" style="color: #4a4a4a">{{  modalTitle }}</span>
                </v-card-title>
                <v-card-text>
                    <v-form ref="form">
                        <v-container>
                            <div v-show="page === 1">
                                <v-row justify="center">
                                    <v-col cols="12" sm="6">
                                        <v-text-field
                                            v-model="veiculo"
                                            :label="$tc('vehicle.self', 1)"
                                            :rules="[veiculoRules]"
                                            type="number"
                                            solo
                                            inputmode="numeric"
                                            pattern="[0-9]*"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </div>
                            <div v-show="page === 2">
                                <v-row justify="center">
                                    <v-col cols="12" sm="6">
                                        <v-text-field
                                            v-model.number="roleta"
                                            :label="$tc('turnstile.self', 1)"
                                            :rules="[roletaRules]"
                                            type="number"
                                            solo
                                            :disabled="!veiculoValidado"
                                            inputmode="numeric"
                                            pattern="[0-9]*"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row justify="center">
                                    <v-container style="max-width: 70vw; max-height: 70vh; position: relative;">
                                        <vue-web-cam 
                                            ref="camera" 
                                            v-show="!pictureTaken"
                                            :device-id="deviceId"
                                            width="100%"
                                            height="100%"
                                            @error="cameraError"
                                            @cameras="onCameras"
                                            @camera-change="cameraChanged"
                                        />
                                        <div v-show="!pictureTaken" class="overlay">
                                          <div class="green-rectangle"></div>
                                        </div>
                                        <img v-if="pictureTaken" :src="picture" alt="Captured Image" style="max-width: 100%; max-height: 100%;"/>
                                    </v-container>
                                </v-row>
                                <v-row justify="center">
                                    <v-btn fab dark large retain-focus-on-click v-if="!pictureTaken && devices.length >= 2"
                                        color="primary" @click="changeCamera">
                                        <v-icon>mdi-camera-flip</v-icon>
                                    </v-btn>
                                    <v-btn fab dark large retain-focus-on-click
                                        color="primary" @click="takePicture">
                                        <v-icon v-if="!pictureTaken">mdi-camera</v-icon>
                                        <v-icon v-else>mdi-camera-retake</v-icon>
                                    </v-btn>
                                </v-row>
                            </div>
                            <div v-show="page === 3">
                                <v-row justify="center">
                                    <v-col cols="12" sm="6">
                                        <v-text-field
                                            v-model.number="odometro"
                                            :label="$t('turnstile.odometer')"
                                            :rules="[odometroRules]"
                                            type="number"
                                            solo
                                            :disabled="!(veiculoValidado && roletaValidada)"
                                            inputmode="numeric"
                                            pattern="[0-9]*"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row justify="center">
                                    <v-container style="max-width: 70vw; max-height: 70vh; position: relative;">
                                        <vue-web-cam 
                                            ref="camera" 
                                            v-show="!pictureTaken"
                                            :device-id="deviceId"
                                            width="100%"
                                            height="100%"
                                            @error="cameraError"
                                            @cameras="onCameras"
                                            @camera-change="cameraChanged"
                                        />
                                        <div v-show="!pictureTaken" class="overlay">
                                          <div class="green-rectangle"></div>
                                        </div>
                                        <img v-if="pictureTaken" :src="picture" alt="Captured Image" style="max-width: 100%; max-height: 100%;"/>
                                    </v-container>
                                </v-row>
                                <v-row justify="center">
                                    <v-btn fab dark large retain-focus-on-click v-if="!pictureTaken && devices.length >= 2"
                                        color="primary" @click="changeCamera">
                                        <v-icon>mdi-camera-flip</v-icon>
                                    </v-btn>
                                    <v-btn fab dark large retain-focus-on-click
                                        color="primary" @click="takePicture">
                                        <v-icon v-if="!pictureTaken">mdi-camera</v-icon>
                                        <v-icon v-else>mdi-camera-retake</v-icon>
                                    </v-btn>
                                </v-row>
                            </div>
                            <div v-show="page === 4">
                                <v-row justify="center">
                                    <v-col cols="12" sm="6">
                                        <v-card>
                                            <v-card-text>
                                                <v-container>
                                                    <v-row justify="start">
                                                        <v-col cols="12" sm="3">
                                                            <strong>{{ $tc('vehicle.self', 1) }}: </strong>
                                                        </v-col>
                                                        <v-col cols="12" sm="3">
                                                            <span>{{ this.veiculo }}</span>
                                                        </v-col>
                                                        <v-col cols="12" sm="2"></v-col>
                                                    </v-row>
                                                    <v-row justify="start">
                                                        <v-col cols="12" sm="3">
                                                            <strong>{{$tc('turnstile.self', 1)}}:</strong>
                                                        </v-col>
                                                        <v-col cols="12" sm="3">
                                                            <span>{{ this.roleta }}</span>
                                                        </v-col>
                                                        <v-col cols="12" sm="2">
                                                            <v-icon 
                                                                v-if="registro.img_roleta_path" color="green">
                                                                mdi-image-check
                                                            </v-icon>
                                                            <v-icon 
                                                                v-else color="red">
                                                                mdi-image-remove
                                                            </v-icon>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row justify="start">
                                                        <v-col cols="12" sm="3">
                                                            <strong>{{$t('turnstile.odometer')}}:</strong>
                                                        </v-col>
                                                        <v-col cols="12" sm="3">
                                                            <span>{{ this.odometro }}</span>
                                                        </v-col>
                                                        <v-col cols="12" sm="2">
                                                            <v-icon 
                                                                v-if="registro.img_odometro_path" color="green">
                                                                mdi-image-check
                                                            </v-icon>
                                                            <v-icon 
                                                                v-else color="red">
                                                                mdi-image-remove
                                                            </v-icon>

                                                        </v-col>
                                                    </v-row>
                                                </v-container>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" dark @click="closeDialog">{{$t('button.cancel')}}</v-btn>
                    <v-btn v-if="page < 4" color="primary" :dark="canNext" @click="goToNextPage" :disabled="!canNext">{{$t('button.next')}}</v-btn>
                    <v-btn v-else color="primary" :dark="canSave" @click="saveRegistro" :disabled="!canSave">{{$t('button.save')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-btn
            color="primary"
            heigth="20"
            @click="openDialog"
            dark
            fab
            large
            fixed
            bottom
            right
            retain-focus-on-click
        >
            <v-icon>mdi-plus</v-icon>
        </v-btn>
    </div>
</template>

<script>
import DateUtils from '../utils/dateutils';
import apiController from "@/utils/apiController";
import EventBus from "@/utils/eventBus";
import { WebCam } from "vue-web-cam";

export default {
    components: {
        'vue-web-cam': WebCam,
    },
   data: () => ({
    user: null,
    token: null,
    config: null,
    editDialog: false,
    deleteDialog: false,
    veiculo: null,
    roleta: null,
    odometro: null,
    dialog: false,
    formValidado: false,
    loading: false,
    dtReset: null,
    camera: null,
    cameraDialog: false,
    cameraStarted: false,
    picture: null,
    fileLoading: false,
    mensagemUpload: "",
    snackColor: "success",
    snackText: "",
    showSnack: false,
    cameraSettings: {
        audio: false,
        video: {
            facingMode: { ideal: "environment" },
            width: { min: 300, max: 1280 },
            height: { min: 600, max: 1344 }
        }
    },
    devices: [],
    deviceSelected: null,
    registros: [],
    veiculos: [],
    registro: {
        id_veiculo: null,
        roleta: null,
        odometro: null,
        id_usuario: null,
        dt_registro: null,
        img_roleta_path: null,
        img_odometro_path: null,
    },
    defaultRegistro: {
        id_veiculo: null,
        roleta: null,
        odometro: null,
        id_usuario: null,
        dt_registro: null,
        img_roleta_path: null,
        img_odometro_path: null,
    },
    page: 0,
    odometroGPS: null,
   }),
   mounted() {
    this.camera = this.$refs.camera;
   },
   computed: {
    headers(){
        return [
        { text: this.$tc('vehicle.self', 1), value: "numero_ordem" },
        { text: this.$tc('turnstile.self', 1), value: "roleta" },
        { text: this.$t('turnstile.odometer'), value: "odometro" }];

    },
    today() {
        return new Date();
    },
    yesterday() {
        let date = new Date();
        date.setDate(date.getDate() - 1);
        return date;
    },
    deviceId() {
        if (this.devices.length === 0) {
            return null;
        }

        let defaultDevice = this.devices.length > 1 ? this.devices[1].deviceId : this.devices[0].deviceId;

        let device = this.devices.find(n => n.deviceId === this.deviceSelected); 
        return device ? device.deviceId : defaultDevice;
    },
    roletaAnterior() {
        let veiculo = this.veiculos.find((v) => v.numero_ordem === this.veiculo);
        return veiculo ? veiculo.roleta : null;
    },
    pictureTaken() {
        return this.picture !== null;
    },
    veiculoValidado() {
        let valid = this.veiculoRules();
        return typeof valid === 'string' ? false : valid;
    },
    roletaValidada() {
        let valid = this.roletaRules();
        return typeof valid === 'string' ? false : valid;
    },
    odometroValidado() {
        let valid = this.odometroRules();
        return typeof valid === 'string' ? false : valid;
    },
    canSave() {
        return this.veiculoValidado && this.roletaValidada && this.odometroValidado;
    },
    canNext() {
        if (this.page === 1) {
            return this.veiculoValidado;
        }

        if (this.page === 2) {
            return this.roletaValidada && this.pictureTaken;
        }

        if (this.page === 3) {
            return this.odometroValidado && this.pictureTaken;
        }

        return false;
    },
    modalTitle() {
        if (this.page === 1) {
            return this.$t('turnstile.addRegister');
        }

        return `${this.$tc('vehicle.self', 1)} ${this.veiculo}`;
        
    }
   },
   watch: {
    '$i18n.locale'() {
      this.initialize();
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    }
   },
   created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.token = sessionStorage.getItem("api");
    this.initialize();
   },
   methods: {
    veiculoRules() {
        if (!this.veiculo || this.veiculo.length === 0) {
            return this.$t('guide.validation.vehicleRequired');
        }
        if (!this.veiculos.map((v) => v.numero_ordem).includes(this.veiculo)) {
            return this.$t('vehicle.activeVehicleNotFound');
        }

        return true;
    },
    roletaRules() {
        if (!this.roleta) {
            return false;
        }

        if (this.config?.ligar_filtros_roleta == 1) {
            if (this.roletaAnterior) {
                let variacao = (this.config.porcentagem_diferenca_roleta * this.roletaAnterior) / 100;
                if (this.roleta < this.roletaAnterior - variacao || this.roleta > this.roletaAnterior + variacao) {
                    return this.$t('turnstile.discrepantTurnstile');
                }
            }
        }

        return true;
    },
    odometroRules() {
        if (!this.odometro) {
            return false;
        }

        if (this.config?.ligar_filtros_odometro == 1) {
            if (this.odometroGPS) {
                let variacao = (this.config.porcentagem_diferenca_odometro * this.odometroGPS) / 100;
                if (this.odometro < this.odometroGPS - variacao || this.odometro > this.odometroGPS + variacao) {
                    return this.$t('turnstile.discrepantOdometer');
                }
            }
        }

        return true;
    },
    initialize() {
        this.getConfig();
        this.getVeiculosAtivos();
        this.getRegistrosUsuario();
    },
    getConfig() {
        apiController.request(apiController.endpoints.getallConfig, {
          onSuccess: (response) => {
            this.config = response.data[0];
          },
          onError: (e) => {
            console.log(this.$t('system.messages.errorAxios'));
            console.log(e.message);
          },
        });
    },
    getRegistrosUsuario() {
        this.loading = true;
        let temp = {
            dti: this.dtReset ? this.dtReset : DateUtils.getDateSQLFormatted(this.yesterday),
            dtf: DateUtils.getDateSQLFormatted(this.today),
            idusuarios: [this.user.id_usuario]
        };

        apiController.request(apiController.endpoints.getRegistrosporusuariosdata, {
            data: temp,
            onSuccess: (response) => {
                this.registros = response.data;
                this.loading = false;
            },
            onError: (e) => {
                this.loading = false;
                console.log("Response : " + e.message);
            },
        });
    },
    getVeiculosAtivos() {
        apiController.request(apiController.endpoints.getallVeiculosativos, {
            onSuccess: (response) => {
                this.veiculos = response.data;
            },
            onError: (e) => {
                console.log("Response : " + e.message);
            },
        });
    },
    openDialog() {
        this.page = 1;
        this.dialog = true;
    },
    closeDialog() {
        this.registro = Object.assign({}, this.defaultRegistro);
        this.dialog = false;
        this.closeCamera();
        this.$nextTick(() => {
            this.formValidado = false;
            this.$refs.form.resetValidation();
            this.veiculo = null;
            this.roleta = null;
            this.odometro = null;
            this.page = 0;
        })
    },
    openCamera() {
        if (!this.camera) {
            this.camera = this.$refs.camera;
        }
        console.log("Starting camera...");
        this.camera.start();
        this.cameraStarted = true;
    },
    cameraError(error) {
      console.error("Camera error:", error);
      this.closeCamera();
    },
    saveRegistro() {
        this.formValidado = this.$refs.form.validate()
        if (this.formValidado) {
            this.registro.id_veiculo = this.veiculos.find((v) => v.numero_ordem == this.veiculo).id_veiculo;
            this.registro.roleta = this.roleta;
            this.registro.odometro = this.odometro;
            this.registro.id_usuario = this.user.id_usuario;
            this.registro.dt_registro = DateUtils.getDateSQLFormatted(this.today);
           apiController.request(apiController.endpoints.insertRegistro, {
                data: this.registro,
                onSuccess: (response) => {
                    const data = response.data || {};
                    const mensagem = data.mensagem || "Registro processado.";
                    const tipo = data.erro ? 'error' : 'success';

                    EventBus.$emit('show-alert', {
                        mensagem,
                        tipo,
                    });

                    if (!data.erro) {
                        this.updateTable();
                    }
                },
                onError: (e) => {
                    console.log("Response : " + e.message);
                },
            });
        }
    },
    apagaTabelaRegistros() {
        this.registros = [];
        this.dtReset = DateUtils.getDateSQLFormatted(this.today);
    },
    resetTabelaRegistros() {
        this.dtReset = null;
        this.getRegistrosUsuario();
    },
    updateTable() {
        this.closeCamera();
        this.getRegistrosUsuario();
        this.closeDialog();
    },
    closeCamera() {
        if (this.camera && this.camera.stop) {
            console.log("Stopping camera...");
            this.camera.stop(); // Stops the camera stream if it's active
        }
        this.cameraStarted = false;
        this.picture = null;
    },
    resetPicture() {
        this.picture = null;
    },
    takePicture() {
        if (!this.camera) {
            this.camera = this.$refs.camera;
        }
       
        if (this.pictureTaken) {
            this.resetPicture();
        } else {
            this.picture = this.camera.capture();
        }
        
    },
    submitFile(page) {
        if (this.picture) {
            this.mensagemUpload = "Loading Image...";
            this.fileLoading = true;
            let body = {
                file: this.picture,
                filename: DateUtils.getDateSQLFormatted(new Date())
            };
            apiController.request(apiController.endpoints.uploadImg, {
                data: body,
                onSuccess: (response) => {
                    if (!response.data.erro) {
                        if (page === 2) {
                            this.registro.img_roleta_path = response.data.path;
                        } else if (page === 3) {
                            this.registro.img_odometro_path = response.data.path;
                        }
                        this.snackColor = "success";
                        this.snackText = response.data.message;
                        this.showSnack = true;
                    } else {
                        this.snackColor = "error";
                        this.snackText = response.data.message;
                        this.showSnack = true;
                    }
                    this.fileLoading = false;
                    this.picture = null;
                },
                onError: (error) => {
                    console.log(error);
                    this.fileLoading = false;
                },
            });
            } else {
                console.log("There are no files.");
            }
        },
        onCameras(cameras) {
            this.devices = cameras;
        },
        cameraChanged() {
            // this.deviceSelected = deviceId;
        },
        changeCamera() {
            let index = this.devices.findIndex((d) => d.deviceId === this.deviceSelected);
            if (index < this.devices.length - 1) {
                this.deviceSelected = this.devices[index + 1].deviceId;
            } else {
                this.deviceSelected = this.devices[0].deviceId;
            }
        },
        goToNextPage() {
            if (this.picture) {
                this.submitFile(this.page);
            }
            
            this.page++;
            if (this.page !== 1) {
                this.openCamera();
            }
        },
        openEditDialog(item) {
            this.registro = Object.assign({}, item);
            this.editDialog = true;
        },
        closeEditDialog() {
            this.regitro = Object.assign({}, this.defaultRegistro);
            this.editDialog = false;
        },
        openDeleteDialog() {
            this.deleteDialog = true;
        },
        deleteRegistro() {
            apiController.request(apiController.endpoints.deleteRegistro, {
                data: this.registro,
                onSuccess: (response) => {
                    const data = response.data || {};
                    EventBus.$emit('show-alert', {
                        mensagem: data.mensagem || (data.erro ? this.$t('turnstile.errorDeleteLaunch') : this.$t('turnstile.successDeleteLaunch')),
                        tipo: data.erro ? 'error' : 'success',
                    });

                    if (!data.erro) {
                        this.updateTable();
                    }
                },
                onError: (error) => {
                    console.log(error);
                },
            });
            this.deleteDialog = false;
            this.closeEditDialog();
        }
   }
}
</script>

<style scoped>
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.green-rectangle {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 80%; 
  height: 30%; 
  transform: translate(-50%, -50%);
  border: 3px solid rgb(0, 255, 0);
  background: transparent;
  pointer-events: none;
}
    
</style>